import React from "react";
import {
  formatCurrency,
  formatDate,
} from "../../../../../../../../utils/formatters";
import DetailsGrid from "../../details-grid";

const columns = [
  {
    label: "Valor a receber",
    field: "valorTotalEmCentavos",
    valueFormatter: formatCurrency,
  },
  {
    label: "Valor principal",
    field: "valorPrincipalAtualizadoEmCentavos",
    valueFormatter: formatCurrency,
  },
  {
    label: "Valor dos honorários",
    field: "honorariosAtualizadoEmCentavos",
    valueGetter: ({
      honorariosAtualizadoEmCentavos,
      honorariosEmPorcentagem,
    }) =>
      [
        formatCurrency(honorariosAtualizadoEmCentavos),
        honorariosEmPorcentagem &&
          `(${honorariosEmPorcentagem}% do valor do precatório)`,
      ]
        .filter((value) => value)
        .join(" "),
  },
  {
    label: "Valor dos juros",
    field: "jurosAtualizadoEmCentavos",
    valueFormatter: formatCurrency,
  },
  {
    label: "Data base",
    field: "dataBase",
    valueFormatter: formatDate,
  },
];

const ModelData = ({ data }) => (
  <DetailsGrid data={data} columns={columns} className="mt-10" />
);

export default ModelData;
